import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  BalanceItem, BokkzJrLogic,
  ClientEntity, FormattedExplanation, Jaarrapportage,
  JaarrapportageEntity, Jaarrekening, TrialBalanceItem
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-voorzieningen',
  templateUrl: './spec-voorzieningen.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    CommonModule
  ],
  styleUrls: ['./spec-voorzieningen.component.scss']
})
export class SpecVoorzieningenComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public provisionsFg = {} as FormGroup;
  public provisionRepairCostsFg = {} as FormGroup;
  public provisionPensionObligationsFg = {} as FormGroup;
  public provisionTaxLiabilitiesFg = {} as FormGroup;
  public provisionEmployeeBenefitsFg = {} as FormGroup;
  public provisionEnvironmentalFg = {} as FormGroup;
  public provisionLegalProceedingsFg = {} as FormGroup;
  public provisionMajorMaintenanceFg = {} as FormGroup;
  public provisionDisposalObligationFg = {} as FormGroup;
  public provisionOnerousContractsFg = {} as FormGroup;
  public provisionParticipatingInterestsFg = {} as FormGroup;
  public provisionRestructuringFg = {} as FormGroup;
  public deferredTaxLiabilitiesFg = {} as FormGroup;
  public provisionWarrantyFg = {} as FormGroup;
  public provisionJubileeBenefitsFg = {} as FormGroup;
  public provisionInsuranceDisabilityRisksFg = {} as FormGroup;
  public provisionDisabilityRisksFg = {} as FormGroup;
  public provisionInsuranceIllnessDisabilityFg = {} as FormGroup;
  public provisionShareBasedPaymentsFg = {} as FormGroup;
  public provisionsOtherFg = {} as FormGroup;

  public provisionsDisclosureFg = {} as FormGroup;
  public provisionPensionObligationsDisclosureFg = {} as FormGroup;
  public provisionRepairCostsDisclosureFg = {} as FormGroup;
  public provisionTaxLiabilitiesDisclosureFg = {} as FormGroup;
  public provisionEmployeeBenefitsDisclosureFg = {} as FormGroup;
  public provisionEnvironmentalDisclosureFg = {} as FormGroup;
  public provisionLegalProceedingsDisclosureFg = {} as FormGroup;
  public provisionMajorMaintenanceDisclosureFg = {} as FormGroup;
  public policyValuationCostsProcessedMajorMaintenanceProvisionDescriptionFg = {} as FormGroup;
  public natureCostsProcessedMajorMaintenanceProvisionDescriptionFg = {} as FormGroup;

  public mainAssumptionsProcessedMajorMaintenanceProvisionDescriptionFg = {} as FormGroup;
  public mainUncertainciesProcessedMajorMaintenanceProvisionDescriptionFg = {} as FormGroup;
  public transitionAccountingProvisionMajorMaintenanceDisclosureFg = {} as FormGroup;
  public provisionDisposalObligationDisclosureFg = {} as FormGroup;
  public provisionOnerousContractsDisclosureFg = {} as FormGroup;

  public natureOfProvisionDescriptionFg = {} as FormGroup;
  public mainCharactaristicsOfPensionArrangementsDescriptionFg = {} as FormGroup;
  public wayInWhichPensionArrangementsAreInsuredByPensionProviderDescriptionFg = {} as FormGroup;

  public applicableOrEstimatedFundingPositionOfPensionProviderDescriptionFg = {} as FormGroup;
  public applicableFundingPositionOfPensionProviderFg = {} as FormGroup;
  public keyElementsRecoveryPlanPensionProviderDescriptionFg = {} as FormGroup;
  public provisionRestructuringDisclosureFg = {} as FormGroup;
  public provisionParticipatingInterestsDisclosureFg = {} as FormGroup;
  public provisionWarrantyDisclosureFg = {} as FormGroup;
  public characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescriptionFg = {} as FormGroup;
  public provisionPensionObligationsDiscountRateDescriptionFg = {} as FormGroup;
  public provisionPensionObligationsSurvivalRateDescriptionFg = {} as FormGroup;

  public provisionPensionObligationsActuarialAssumptionsOtherDescriptionFg = {} as FormGroup;
  public pensionClaimEffectIncomeExpensesStatementDescriptionFg = {} as FormGroup;
  public provisionJubileeBenefitsDisclosureFg = {} as FormGroup;
  public deferredTaxLiabilitiesDisclosureFg = {} as FormGroup;
  public provisionInsuranceDisabilityRisksDisclosureFg = {} as FormGroup;
  public provisionDisabilityRisksDisclosureFg = {} as FormGroup;
  public provisionInsuranceIllnessDisabilityDisclosureFg = {} as FormGroup;
  public provisionShareBasedPaymentsDisclosureFg = {} as FormGroup;
  public provisionsOtherDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.provisionsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.provisionRepairCostsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionPensionObligationsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionTaxLiabilitiesFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionEmployeeBenefitsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionEnvironmentalFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionLegalProceedingsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionMajorMaintenanceFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionDisposalObligationFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionOnerousContractsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionParticipatingInterestsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionRestructuringFg = this.jrDataService.createFormGroupBalanceItem();
    this.deferredTaxLiabilitiesFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionWarrantyFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionJubileeBenefitsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionInsuranceDisabilityRisksFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionDisabilityRisksFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionInsuranceIllnessDisabilityFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionShareBasedPaymentsFg = this.jrDataService.createFormGroupBalanceItem();
    this.provisionsOtherFg = this.jrDataService.createFormGroupBalanceItem();

    this.provisionsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionPensionObligationsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionRepairCostsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionTaxLiabilitiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionEmployeeBenefitsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionEnvironmentalDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionLegalProceedingsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionMajorMaintenanceDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.policyValuationCostsProcessedMajorMaintenanceProvisionDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.natureCostsProcessedMajorMaintenanceProvisionDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();

    this.mainAssumptionsProcessedMajorMaintenanceProvisionDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.mainUncertainciesProcessedMajorMaintenanceProvisionDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.transitionAccountingProvisionMajorMaintenanceDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionDisposalObligationDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionOnerousContractsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.natureOfProvisionDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.mainCharactaristicsOfPensionArrangementsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();

    this.applicableOrEstimatedFundingPositionOfPensionProviderDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.applicableFundingPositionOfPensionProviderFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.keyElementsRecoveryPlanPensionProviderDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionRestructuringDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionParticipatingInterestsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionWarrantyDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionPensionObligationsDiscountRateDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionPensionObligationsSurvivalRateDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();

    this.provisionPensionObligationsActuarialAssumptionsOtherDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.pensionClaimEffectIncomeExpensesStatementDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionJubileeBenefitsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.deferredTaxLiabilitiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionInsuranceDisabilityRisksDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionDisabilityRisksDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionInsuranceIllnessDisabilityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionShareBasedPaymentsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.provisionsOtherDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {

    const voorzieningen = value.rapportage?.jaarrekeningen?.at(0)?.balans?.voorzieningen;

    if (voorzieningen) {
      this.provisionsFg.reset()

      if (voorzieningen.provisions) {
        this.provisionsFg.patchValue(voorzieningen.provisions, {emitEvent: false})
      }

      const uitsplitsing = voorzieningen.voorzieningenUitsplitsing;
      const tekstueel = voorzieningen.voorzieningenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing?.provisionRepairCosts) {
          const subItem = uitsplitsing.provisionRepairCosts;
          this.provisionRepairCostsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionRepairCostsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionPensionObligations) {
          const subItem = uitsplitsing.provisionPensionObligations;
          this.provisionPensionObligationsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionPensionObligationsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionTaxLiabilities) {
          const subItem = uitsplitsing.provisionTaxLiabilities;
          this.provisionTaxLiabilitiesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionTaxLiabilitiesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionEmployeeBenefits) {
          const subItem = uitsplitsing.provisionEmployeeBenefits;
          this.provisionEmployeeBenefitsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionEmployeeBenefitsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionEnvironmental) {
          const subItem = uitsplitsing.provisionEnvironmental;
          this.provisionEnvironmentalFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionEnvironmentalFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionLegalProceedings) {
          const subItem = uitsplitsing.provisionLegalProceedings;
          this.provisionLegalProceedingsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionLegalProceedingsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionMajorMaintenance) {
          const subItem = uitsplitsing.provisionMajorMaintenance;
          this.provisionMajorMaintenanceFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionMajorMaintenanceFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionDisposalObligation) {
          const subItem = uitsplitsing.provisionDisposalObligation;
          this.provisionDisposalObligationFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionDisposalObligationFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionOnerousContracts) {
          const subItem = uitsplitsing.provisionOnerousContracts;
          this.provisionOnerousContractsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionOnerousContractsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionParticipatingInterests) {
          const subItem = uitsplitsing.provisionParticipatingInterests;
          this.provisionParticipatingInterestsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionParticipatingInterestsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionRestructuring) {
          const subItem = uitsplitsing.provisionRestructuring;
          this.provisionRestructuringFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionRestructuringFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.deferredTaxLiabilities) {
          const subItem = uitsplitsing.deferredTaxLiabilities;
          this.deferredTaxLiabilitiesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.deferredTaxLiabilitiesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionWarranty) {
          const subItem = uitsplitsing.provisionWarranty;
          this.provisionWarrantyFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionWarrantyFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionJubileeBenefits) {
          const subItem = uitsplitsing.provisionJubileeBenefits;
          this.provisionJubileeBenefitsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionJubileeBenefitsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionInsuranceDisabilityRisks) {
          const subItem = uitsplitsing.provisionInsuranceDisabilityRisks;
          this.provisionInsuranceDisabilityRisksFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionInsuranceDisabilityRisksFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionDisabilityRisks) {
          const subItem = uitsplitsing.provisionDisabilityRisks;
          this.provisionDisabilityRisksFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionDisabilityRisksFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionInsuranceIllnessDisability) {
          const subItem = uitsplitsing.provisionInsuranceIllnessDisability;
          this.provisionInsuranceIllnessDisabilityFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionInsuranceIllnessDisabilityFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionShareBasedPayments) {
          const subItem = uitsplitsing.provisionShareBasedPayments;
          this.provisionShareBasedPaymentsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionShareBasedPaymentsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.provisionsOther) {
          const subItem = uitsplitsing.provisionsOther;
          this.provisionsOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.provisionsOtherFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.provisionsDisclosure) {
          this.provisionsDisclosureFg.patchValue(tekstueel.provisionsDisclosure);
        }
        if (tekstueel.provisionPensionObligationsDisclosure) {
          this.provisionPensionObligationsDisclosureFg.patchValue(tekstueel.provisionPensionObligationsDisclosure);
        }
        if (tekstueel.provisionRepairCostsDisclosure) {
          this.provisionRepairCostsDisclosureFg.patchValue(tekstueel.provisionRepairCostsDisclosure);
        }
        if (tekstueel.provisionTaxLiabilitiesDisclosure) {
          this.provisionTaxLiabilitiesDisclosureFg.patchValue(tekstueel.provisionTaxLiabilitiesDisclosure);
        }
        if (tekstueel.provisionEmployeeBenefitsDisclosure) {
          this.provisionEmployeeBenefitsDisclosureFg.patchValue(tekstueel.provisionEmployeeBenefitsDisclosure);
        }
        if (tekstueel.provisionEnvironmentalDisclosure) {
          this.provisionEnvironmentalDisclosureFg.patchValue(tekstueel.provisionEnvironmentalDisclosure);
        }
        if (tekstueel.provisionLegalProceedingsDisclosure) {
          this.provisionLegalProceedingsDisclosureFg.patchValue(tekstueel.provisionLegalProceedingsDisclosure);
        }
        if (tekstueel.provisionMajorMaintenanceDisclosure) {
          this.provisionMajorMaintenanceDisclosureFg.patchValue(tekstueel.provisionMajorMaintenanceDisclosure);
        }
        if (tekstueel.policyValuationCostsProcessedMajorMaintenanceProvisionDescription) {
          this.policyValuationCostsProcessedMajorMaintenanceProvisionDescriptionFg.patchValue(tekstueel.policyValuationCostsProcessedMajorMaintenanceProvisionDescription);
        }
        if (tekstueel.natureCostsProcessedMajorMaintenanceProvisionDescription) {
          this.natureCostsProcessedMajorMaintenanceProvisionDescriptionFg.patchValue(tekstueel.natureCostsProcessedMajorMaintenanceProvisionDescription);
        }
        if (tekstueel.mainAssumptionsProcessedMajorMaintenanceProvisionDescription) {
          this.mainAssumptionsProcessedMajorMaintenanceProvisionDescriptionFg.patchValue(tekstueel.mainAssumptionsProcessedMajorMaintenanceProvisionDescription);
        }
        if (tekstueel.mainUncertainciesProcessedMajorMaintenanceProvisionDescription) {
          this.mainUncertainciesProcessedMajorMaintenanceProvisionDescriptionFg.patchValue(tekstueel.mainUncertainciesProcessedMajorMaintenanceProvisionDescription);
        }
        if (tekstueel.transitionAccountingProvisionMajorMaintenanceDisclosure) {
          this.transitionAccountingProvisionMajorMaintenanceDisclosureFg.patchValue(tekstueel.transitionAccountingProvisionMajorMaintenanceDisclosure);
        }
        if (tekstueel.provisionDisposalObligationDisclosure) {
          this.provisionDisposalObligationDisclosureFg.patchValue(tekstueel.provisionDisposalObligationDisclosure);
        }
        if (tekstueel.provisionOnerousContractsDisclosure) {
          this.provisionOnerousContractsDisclosureFg.patchValue(tekstueel.provisionOnerousContractsDisclosure);
        }
        if (tekstueel.natureOfProvisionDescription) {
          this.natureOfProvisionDescriptionFg.patchValue(tekstueel.natureOfProvisionDescription);
        }
        if (tekstueel.mainCharactaristicsOfPensionArrangementsDescription) {
          this.mainCharactaristicsOfPensionArrangementsDescriptionFg.patchValue(tekstueel.mainCharactaristicsOfPensionArrangementsDescription);
        }
        if (tekstueel.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescription) {
          this.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescriptionFg.patchValue(tekstueel.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescription);
        }
        if (tekstueel.applicableOrEstimatedFundingPositionOfPensionProviderDescription) {
          this.applicableOrEstimatedFundingPositionOfPensionProviderDescriptionFg.patchValue(tekstueel.applicableOrEstimatedFundingPositionOfPensionProviderDescription);
        }
        if (tekstueel.applicableFundingPositionOfPensionProvider) {
          this.applicableFundingPositionOfPensionProviderFg.patchValue(tekstueel.applicableFundingPositionOfPensionProvider);
        }
        if (tekstueel.keyElementsRecoveryPlanPensionProviderDescription) {
          this.keyElementsRecoveryPlanPensionProviderDescriptionFg.patchValue(tekstueel.keyElementsRecoveryPlanPensionProviderDescription);
        }
        if (tekstueel.provisionRestructuringDisclosure) {
          this.provisionRestructuringDisclosureFg.patchValue(tekstueel.provisionRestructuringDisclosure);
        }
        if (tekstueel.provisionParticipatingInterestsDisclosure) {
          this.provisionParticipatingInterestsDisclosureFg.patchValue(tekstueel.provisionParticipatingInterestsDisclosure);
        }
        if (tekstueel.provisionWarrantyDisclosure) {
          this.provisionWarrantyDisclosureFg.patchValue(tekstueel.provisionWarrantyDisclosure);
        }
        if (tekstueel.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescription) {
          this.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescriptionFg.patchValue(tekstueel.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescription);
        }
        if (tekstueel.provisionPensionObligationsDiscountRateDescription) {
          this.provisionPensionObligationsDiscountRateDescriptionFg.patchValue(tekstueel.provisionPensionObligationsDiscountRateDescription);
        }
        if (tekstueel.provisionPensionObligationsSurvivalRateDescription) {
          this.provisionPensionObligationsSurvivalRateDescriptionFg.patchValue(tekstueel.provisionPensionObligationsSurvivalRateDescription);
        }
        if (tekstueel.provisionPensionObligationsActuarialAssumptionsOtherDescription) {
          this.provisionPensionObligationsActuarialAssumptionsOtherDescriptionFg.patchValue(tekstueel.provisionPensionObligationsActuarialAssumptionsOtherDescription);
        }
        if (tekstueel.pensionClaimEffectIncomeExpensesStatementDescription) {
          this.pensionClaimEffectIncomeExpensesStatementDescriptionFg.patchValue(tekstueel.pensionClaimEffectIncomeExpensesStatementDescription);
        }
        if (tekstueel.provisionJubileeBenefitsDisclosure) {
          this.provisionJubileeBenefitsDisclosureFg.patchValue(tekstueel.provisionJubileeBenefitsDisclosure);
        }
        if (tekstueel.deferredTaxLiabilitiesDisclosure) {
          this.deferredTaxLiabilitiesDisclosureFg.patchValue(tekstueel.deferredTaxLiabilitiesDisclosure);
        }
        if (tekstueel.provisionInsuranceDisabilityRisksDisclosure) {
          this.provisionInsuranceDisabilityRisksDisclosureFg.patchValue(tekstueel.provisionInsuranceDisabilityRisksDisclosure);
        }
        if (tekstueel.provisionDisabilityRisksDisclosure) {
          this.provisionDisabilityRisksDisclosureFg.patchValue(tekstueel.provisionDisabilityRisksDisclosure);
        }
        if (tekstueel.provisionInsuranceIllnessDisabilityDisclosure) {
          this.provisionInsuranceIllnessDisabilityDisclosureFg.patchValue(tekstueel.provisionInsuranceIllnessDisabilityDisclosure);
        }
        if (tekstueel.provisionShareBasedPaymentsDisclosure) {
          this.provisionShareBasedPaymentsDisclosureFg.patchValue(tekstueel.provisionShareBasedPaymentsDisclosure);
        }
        if (tekstueel.provisionsOtherDisclosure) {
          this.provisionsOtherDisclosureFg.patchValue(tekstueel.provisionsOtherDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.provisionsFg.updateValueAndValidity();
    this.provisionRepairCostsFg.updateValueAndValidity();
    this.provisionPensionObligationsFg.updateValueAndValidity();
    this.provisionTaxLiabilitiesFg.updateValueAndValidity();
    this.provisionEmployeeBenefitsFg.updateValueAndValidity();
    this.provisionEnvironmentalFg.updateValueAndValidity();
    this.provisionLegalProceedingsFg.updateValueAndValidity();
    this.provisionMajorMaintenanceFg.updateValueAndValidity();
    this.provisionDisposalObligationFg.updateValueAndValidity();
    this.provisionOnerousContractsFg.updateValueAndValidity();
    this.provisionParticipatingInterestsFg.updateValueAndValidity();
    this.provisionRestructuringFg.updateValueAndValidity();
    this.deferredTaxLiabilitiesFg.updateValueAndValidity();
    this.provisionWarrantyFg.updateValueAndValidity();
    this.provisionJubileeBenefitsFg.updateValueAndValidity();
    this.provisionInsuranceDisabilityRisksFg.updateValueAndValidity();
    this.provisionDisabilityRisksFg.updateValueAndValidity();
    this.provisionInsuranceIllnessDisabilityFg.updateValueAndValidity();
    this.provisionShareBasedPaymentsFg.updateValueAndValidity();
    this.provisionsOtherFg.updateValueAndValidity();

    this.provisionsDisclosureFg.updateValueAndValidity();
    this.provisionPensionObligationsDisclosureFg.updateValueAndValidity();
    this.provisionRepairCostsDisclosureFg.updateValueAndValidity();
    this.provisionTaxLiabilitiesDisclosureFg.updateValueAndValidity();
    this.provisionEmployeeBenefitsDisclosureFg.updateValueAndValidity();
    this.provisionEnvironmentalDisclosureFg.updateValueAndValidity();
    this.provisionLegalProceedingsDisclosureFg.updateValueAndValidity();
    this.provisionMajorMaintenanceDisclosureFg.updateValueAndValidity();
    this.policyValuationCostsProcessedMajorMaintenanceProvisionDescriptionFg.updateValueAndValidity();
    this.natureCostsProcessedMajorMaintenanceProvisionDescriptionFg.updateValueAndValidity();
    this.mainAssumptionsProcessedMajorMaintenanceProvisionDescriptionFg.updateValueAndValidity();
    this.mainUncertainciesProcessedMajorMaintenanceProvisionDescriptionFg.updateValueAndValidity();
    this.transitionAccountingProvisionMajorMaintenanceDisclosureFg.updateValueAndValidity();
    this.provisionDisposalObligationDisclosureFg.updateValueAndValidity();
    this.provisionOnerousContractsDisclosureFg.updateValueAndValidity();
    this.natureOfProvisionDescriptionFg.updateValueAndValidity();
    this.mainCharactaristicsOfPensionArrangementsDescriptionFg.updateValueAndValidity();
    this.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescriptionFg.updateValueAndValidity();
    this.applicableOrEstimatedFundingPositionOfPensionProviderDescriptionFg.updateValueAndValidity();
    this.applicableFundingPositionOfPensionProviderFg.updateValueAndValidity();
    this.keyElementsRecoveryPlanPensionProviderDescriptionFg.updateValueAndValidity();
    this.provisionRestructuringDisclosureFg.updateValueAndValidity();
    this.provisionParticipatingInterestsDisclosureFg.updateValueAndValidity();
    this.provisionWarrantyDisclosureFg.updateValueAndValidity();
    this.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescriptionFg.updateValueAndValidity();
    this.provisionPensionObligationsDiscountRateDescriptionFg.updateValueAndValidity();
    this.provisionPensionObligationsSurvivalRateDescriptionFg.updateValueAndValidity();
    this.provisionPensionObligationsActuarialAssumptionsOtherDescriptionFg.updateValueAndValidity();
    this.pensionClaimEffectIncomeExpensesStatementDescriptionFg.updateValueAndValidity();
    this.provisionJubileeBenefitsDisclosureFg.updateValueAndValidity();
    this.deferredTaxLiabilitiesDisclosureFg.updateValueAndValidity();
    this.provisionInsuranceDisabilityRisksDisclosureFg.updateValueAndValidity();
    this.provisionDisabilityRisksDisclosureFg.updateValueAndValidity();
    this.provisionInsuranceIllnessDisabilityDisclosureFg.updateValueAndValidity();
    this.provisionShareBasedPaymentsDisclosureFg.updateValueAndValidity();
    this.provisionsOtherDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          voorzieningen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorzieningen,
            voorzieningenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorzieningen?.voorzieningenUitsplitsing,
              provisionRepairCosts: this.provisionRepairCostsFg.value,
              provisionPensionObligations: this.provisionPensionObligationsFg.value,
              provisionTaxLiabilities: this.provisionTaxLiabilitiesFg.value,
              provisionEmployeeBenefits: this.provisionEmployeeBenefitsFg.value,
              provisionEnvironmental: this.provisionEnvironmentalFg.value,
              provisionLegalProceedings: this.provisionLegalProceedingsFg.value,
              provisionMajorMaintenance: this.provisionMajorMaintenanceFg.value,
              provisionDisposalObligation: this.provisionDisposalObligationFg.value,
              provisionOnerousContracts: this.provisionOnerousContractsFg.value,
              provisionParticipatingInterests: this.provisionParticipatingInterestsFg.value,
              provisionRestructuring: this.provisionRestructuringFg.value,
              deferredTaxLiabilities: this.deferredTaxLiabilitiesFg.value,
              provisionWarranty: this.provisionWarrantyFg.value,
              provisionJubileeBenefits: this.provisionJubileeBenefitsFg.value,
              provisionInsuranceDisabilityRisks: this.provisionInsuranceDisabilityRisksFg.value,
              provisionDisabilityRisks: this.provisionDisabilityRisksFg.value,
              provisionInsuranceIllnessDisability: this.provisionInsuranceIllnessDisabilityFg.value,
              provisionShareBasedPayments: this.provisionShareBasedPaymentsFg.value,
              provisionsOther: this.provisionsOtherFg.value,
            },
            voorzieningenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorzieningen?.voorzieningenTekstueel,
              provisionsDisclosure: this.provisionsDisclosureFg.value,
              provisionPensionObligationsDisclosure: this.provisionPensionObligationsDisclosureFg.value,
              provisionRepairCostsDisclosure: this.provisionRepairCostsDisclosureFg.value,
              provisionTaxLiabilitiesDisclosure: this.provisionTaxLiabilitiesDisclosureFg.value,
              provisionEmployeeBenefitsDisclosure: this.provisionEmployeeBenefitsDisclosureFg.value,
              provisionEnvironmentalDisclosure: this.provisionEnvironmentalDisclosureFg.value,
              provisionLegalProceedingsDisclosure: this.provisionLegalProceedingsDisclosureFg.value,
              provisionMajorMaintenanceDisclosure: this.provisionMajorMaintenanceDisclosureFg.value,
              policyValuationCostsProcessedMajorMaintenanceProvisionDescription: this.policyValuationCostsProcessedMajorMaintenanceProvisionDescriptionFg.value,
              natureCostsProcessedMajorMaintenanceProvisionDescription: this.natureCostsProcessedMajorMaintenanceProvisionDescriptionFg.value,
              mainAssumptionsProcessedMajorMaintenanceProvisionDescription: this.mainAssumptionsProcessedMajorMaintenanceProvisionDescriptionFg.value,
              mainUncertainciesProcessedMajorMaintenanceProvisionDescription: this.mainUncertainciesProcessedMajorMaintenanceProvisionDescriptionFg.value,
              transitionAccountingProvisionMajorMaintenanceDisclosure: this.transitionAccountingProvisionMajorMaintenanceDisclosureFg.value,
              provisionDisposalObligationDisclosure: this.provisionDisposalObligationDisclosureFg.value,
              provisionOnerousContractsDisclosure: this.provisionOnerousContractsDisclosureFg.value,
              natureOfProvisionDescription: this.natureOfProvisionDescriptionFg.value,
              mainCharactaristicsOfPensionArrangementsDescription: this.mainCharactaristicsOfPensionArrangementsDescriptionFg.value,
              wayInWhichPensionArrangementsAreInsuredByPensionProviderDescription: this.wayInWhichPensionArrangementsAreInsuredByPensionProviderDescriptionFg.value,
              applicableOrEstimatedFundingPositionOfPensionProviderDescription: this.applicableOrEstimatedFundingPositionOfPensionProviderDescriptionFg.value,
              applicableFundingPositionOfPensionProvider: this.applicableFundingPositionOfPensionProviderFg.value,
              keyElementsRecoveryPlanPensionProviderDescription: this.keyElementsRecoveryPlanPensionProviderDescriptionFg.value,
              provisionRestructuringDisclosure: this.provisionRestructuringDisclosureFg.value,
              provisionParticipatingInterestsDisclosure: this.provisionParticipatingInterestsDisclosureFg.value,
              provisionWarrantyDisclosure: this.provisionWarrantyDisclosureFg.value,
              characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescription: this.characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescriptionFg.value,
              provisionPensionObligationsDiscountRateDescription: this.provisionPensionObligationsDiscountRateDescriptionFg.value,
              provisionPensionObligationsSurvivalRateDescription: this.provisionPensionObligationsSurvivalRateDescriptionFg.value,
              provisionPensionObligationsActuarialAssumptionsOtherDescription: this.provisionPensionObligationsActuarialAssumptionsOtherDescriptionFg.value,
              pensionClaimEffectIncomeExpensesStatementDescription: this.pensionClaimEffectIncomeExpensesStatementDescriptionFg.value,
              provisionJubileeBenefitsDisclosure: this.provisionJubileeBenefitsDisclosureFg.value,
              deferredTaxLiabilitiesDisclosure: this.deferredTaxLiabilitiesDisclosureFg.value,
              provisionInsuranceDisabilityRisksDisclosure: this.provisionInsuranceDisabilityRisksDisclosureFg.value,
              provisionDisabilityRisksDisclosure: this.provisionDisabilityRisksDisclosureFg.value,
              provisionInsuranceIllnessDisabilityDisclosure: this.provisionInsuranceIllnessDisabilityDisclosureFg.value,
              provisionShareBasedPaymentsDisclosure: this.provisionShareBasedPaymentsDisclosureFg.value,
              provisionsOtherDisclosure: this.provisionsOtherDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}
